import { SVGProps } from "react"

export const LeftChevron = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={10} height={16} fill="none" {...props}>
    <path stroke="#067BF2" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8.286 14.494 1.714 7.922l6.572-6.416" />
  </svg>
)
